module.exports = __webpack_public_path__ + "img/figure-18.5e6d7068.png";